<template>
    <div>
        <b-modal id="modalMilimetragem" data-backdrop="static" data-keyboard="false" centered
            :title="this.$t('Informar Aferição') + ' - ' + nr_placa.nr_placa">

            <div id="globalAfericoes">

                <div id="veiculoPneus" class="veiculo-fixo text-center scalable">
                    <div class="chassi"></div>
                </div>

                <div v-if="pneuVazio" class="alert alert-danger text-center" role="alert">
                    Existem posições sem pneu aplicado!<br>
                    Entre no menu Movimentações e aplique<br> os pneus deste caminhão.
                </div>

                <modal-registra-afericao ref="childRegistraAfericao" :pneu="informacaoPneu" v-if="modalShow"
                    :afericoesFeitas="arrayAfericoes" @closeModal="modalShow = false"
                    @adicionarAfericao="adicionarAfericao"></modal-registra-afericao>

                <div class="container">

                    <div class="align-items-center justify-content-center" style="display: grid">
                        <!-- Informa KM -->
                        <div class="col-auto d-flex align-items-center">
                            <label for="km_informado" class="me-2 mb-0">{{ $t('Informar KM') }}:</label>
                            <input
                                id="km_informado"
                                type="text"
                                class="form-control form-control-sm me-4"
                                v-model="km_informado"
                                style="width: 120px;"
                            />
                        </div>

                        <!-- Inverte Pneu -->
                        <!-- <div class="pl-5 pt-2 col-auto d-flex align-items-center">
                            <input
                                type="checkbox"
                                id="inverter"
                                v-model="inverterPneu"
                                class="form-check-input me-2"
                            />
                            <label for="inverter" class="form-check-label mb-0">{{ $t('Inverter pneus') }}</label>
                        </div> -->
                    </div>
                    <upload-arquivos-afericao></upload-arquivos-afericao>
                </div>
            </div>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <div class="row center" style="justify-content: center;">
                        <b-button class="mr-2" variant="danger" size="lg" @click="cancel(), modalShow = false">
                            {{ $t('Cancelar') }}
                        </b-button>
                        <b-button v-if="showBtnFinalizar" size="lg" variant="success" :disabled="disabledFinalizar || pneuVazio"
                            @click="registrarAfericao">
                            {{ $t('Informar Aferição') }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import UploadArquivosAfericao from '../Modais/UploadArquivosAfericao.vue';
import ModalRegistraAfericao from './ModalRegistraAfericao.vue';

export default {
    name: "ModalExterna",
    props: {
        nr_placa: {}
    },
    components: {
        ModalRegistraAfericao,
        UploadArquivosAfericao
    },

    data() {
        return {
            arrayAfericoes: [],
            informacaoPneu: '',
            modalShow: false,
            submitAfericao: [],
            disabledFinalizar: false,
            km_informado: '',
            inverterPneu: false,
            showBtnFinalizar: true,
            pneuVazio: false
        };
    },

    computed: {
        veiculo() {
            const veiculo = this.$store.getters['borracharia/getVeiculo']

            // this.km_informado = veiculo

            return veiculo
        }
    },

    methods: {
        adicionarAfericao(afericao) {
            this.modalShow = false
            // this.showBtnFinalizar = !this.modalShow

            if (localStorage.afericao == undefined) {
                const dataInicio = {
                    nr_placa: 'AAA000',
                    afericoes: []
                }
                localStorage.setItem('afericao', JSON.stringify(dataInicio));
            }

            const localAfericao = JSON.parse(localStorage.afericao)

            if (this.nr_placa.nr_placa == localAfericao.nr_placa) {
                this.submitAfericao = localAfericao.afericoes
            } else {
                this.submitAfericao = []
            }

            var indice = this.submitAfericao.findIndex(function (item) {
                if (item.nr_posicao && item.ds_lado) {
                    return item.nr_posicao === afericao.nr_posicao && item.ds_lado === afericao.ds_lado;
                }

                return -1
            });

            if (indice !== -1) {
                this.submitAfericao[indice] = afericao;
            } else {
                this.submitAfericao.push(afericao);
            }

            const todosPneus = document.querySelectorAll('.pneu-fixo')

            this.submitAfericao.forEach(function (afe) {
                todosPneus.forEach((pneu) => {
                    if (pneu.dataset.posicao == afe.nr_posicao && pneu.dataset.lado == afe.ds_lado) {
                        pneu.classList.add('pneuSelecionadoAfericao')
                    }
                })
            })

            const data = {
                nr_placa: this.nr_placa.nr_placa,
                afericoes: this.submitAfericao
            }

            localStorage.afericao = JSON.stringify(data)

            if (data.afericoes.length === todosPneus.length) {
                this.disabledFinalizar = false
            }
            this.adicionarClassePneu()
        },

        gerarCaminhao() {
            this.km_informado = parseInt(this.veiculo.km_atual)
            let pneus = this.$store.getters['borracharia/getAfericao']

            for (let i = 1; i <= pneus.length; i++) {
                this.$nextTick(() => {
                    if (pneus[i]) {
                        var divChassi = document.createElement('div')

                        divChassi.classList.add(`eixo`)
                        divChassi.classList.add(`eixo-${pneus[i - 1].nr_posicao}`)

                        if (pneus[i].ds_lado == 'EEE') {
                            divChassi.classList.add(`eixo-estepe-1`)
                        }
                        // console.log(pneus[i].eixo_direcional)
                        
                        if(pneus[i - 1].eixo_direcional){
                            divChassi.classList.add(`eixo-direcional-${pneus[i - 1].nr_posicao}`)
                        }
                        let divPai = document.getElementById('veiculoPneus')
                        divPai.classList.add(`margin-afericao-${pneus[i - 1].nr_posicao}`)

                        divPai.appendChild(divChassi)
                    }

                    // document.getElementById('chassi').style.width = `${pneus.length}00 px;`
                })
            }

            let divChassi = document.querySelector('.chassi')
            let contador_step = 0
            let contador_direcional = 1

            pneus.forEach((pneu, index) => {
                let divPneu = document.createElement('b-button')

                divPneu.innerText = pneu.nr_fogo
                divPneu.value = pneu.vl_mm
                divPneu.dataset.idpneu = pneu.idpneu
                divPneu.dataset.posicao = pneu.nr_posicao
                divPneu.dataset.lado = pneu.ds_lado
                divPneu.dataset.vida = pneu.nr_vida
                              
                if(pneu.ds_lado == 'EEE') {
                        if(pneu.idpneu == null) return false

                        console.log('entrou')
                        // console.log(pneu)
                        console.log(pneu.idpneu)
     
                        contador_step = contador_step + 1
                        divPneu.classList.add(`step-${contador_step}`)
                        divPneu.classList.add(`step-1`)
                        divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)   
                        // divChassi.classList.add(`chassi-${pneu.nr_posicao}`)
                }

                divPneu.classList.add(`pneu-fixo`)

                    divPneu.classList.add(`coluna-${pneu.nr_posicao}`)

                if(pneu.ds_lado != 'EEE') {
                    divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                    divChassi.classList.add(`chassi-${pneu.nr_posicao}`)
                    
                }

                if(pneu.eixo_direcional) {
                    contador_direcional = contador_direcional + 1
                    divPneu.classList.add(`pneu-direcional-${contador_direcional}`)
                    divChassi.classList.add(`chassi-direcional-${index}`)
                }

                // if(pneu.ds_lado == 'EEE') {
                //         if(pneu.id_pneu == null){
                //             return false
                //         }

                //         console.log('entrou')
                //         console.log(pneu)
                //         console.log(pneu.id_pneu)
     
                //         contador_step = contador_step + 1
                //         divPneu.classList.add(`step-${pneu.nr_posicao}`)
                //         divPneu.classList.add(`step-1`)
                //         divChassi.classList.remove(`chassi-${pneu.nr_posicao}`)
                // }

                if (pneu.ds_lado == "EE") {
                    divPneu.classList.add('externo-esquerdo')
                } else if (pneu.ds_lado == "EI") {
                    divPneu.classList.add('interno-esquerdo')
                } else if (pneu.ds_lado == "DE") {
                    divPneu.classList.add('externo-direito')
                } else if (pneu.ds_lado == "DI") {
                    divPneu.classList.add('interno-direito')
                }

                let divPai = document.getElementById('veiculoPneus')

                divPai.appendChild(divPneu)
            })

        },

        adicionarClassePneu() {
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            let aferTemp = {}

            if (localStorage.afericao != undefined) {
                aferTemp = JSON.parse(localStorage.afericao)

                todosPneus.forEach((pneu) => {
                    aferTemp.afericoes.forEach(function (afe) {
                        if (pneu.dataset.posicao == afe.nr_posicao && pneu.dataset.lado == afe.ds_lado) {
                            pneu.classList.add('pneuSelecionadoAfericao')
                        }
                    })
                })
            }

            let validaPneuVazio = false

            todosPneus.forEach((pneu) => {
                // console.log(pneu)
                if(pneu.innerText == ''){
                    validaPneuVazio = true
                }
            })

            this.pneuVazio = validaPneuVazio

        },

        adicionarAcao() {
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            todosPneus.forEach(acaoPneu => {
                acaoPneu.addEventListener('click', () => {
                    this.modalShow = false
                    // this.showBtnFinalizar = !this.modalShow
                    console.log(this.nr_placa)
                    const afericoesFeitas = acaoPneu.value
                    this.informacaoPneu = {
                        nr_fogo: acaoPneu.innerText,
                        idpneu: acaoPneu.dataset.idpneu,
                        nr_posicao: acaoPneu.dataset.posicao,
                        ds_lado: acaoPneu.dataset.lado,
                        nr_vida: acaoPneu.dataset.vida
                    }

                    const arrayAfericoesTemp = afericoesFeitas.split('|')

                    this.arrayAfericoes = arrayAfericoesTemp.map(function (string, indice) {
                        return { indice: indice, valor: string };
                    });

                    this.modalShow = true
                    // this.showBtnFinalizar = !this.modalShow
                    setTimeout(() => {
                        var div = document.getElementById("globalAfericoes");
                        div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                        this.$refs.childRegistraAfericao.populaArray()

                    }, 100)

                })
            })
        },

        registrarAfericao() {
            if (localStorage.afericao == undefined) {
                const dataInicio = {
                    nr_placa: 'AAA000',
                    afericoes: []
                }
                localStorage.setItem('afericao', JSON.stringify(dataInicio));
            }

            const localAfericao = JSON.parse(localStorage.afericao)
            const todosPneus = document.querySelectorAll('.pneu-fixo')

            if (!this.km_informado) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Informe o KM atual!',
                    icon: 'warning'
                })

                return false
            }

            if (localAfericao.afericoes.length < todosPneus.length) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: this.$t('Faça a leitura de todos os pneus para registrar'),
                    icon: 'warning'
                })

                return false
            }

            localAfericao.km_informado = this.km_informado

            localAfericao.inverterPneu = this.inverterPneu

            this.disabledFinalizar = true

            if (document.getElementById('formFilesAfericao').value != '') {

                const files = this.$store.state.borracharia.filesUpload
                const formData = new FormData();

                for (let i = 0; i < files.length; i++) {
                    formData.append('files[]', files[i]);
                }
                this.$store.dispatch('borracharia/submitAfericao', { data: localAfericao }).then(response => {
                    localAfericao.nr_seq_evento = response.data.insert_eventos.nr_sequencial
                    this.$store.dispatch(`borracharia/uploadFilesAfericao`, { data: formData, dataPneu: localAfericao })

                    this.limparAfericoes()
                })

            } else {
                this.$store.dispatch('borracharia/submitAfericao', { data: localAfericao }).then(() => {
                    this.limparAfericoes()
                })
            }


        },

        limparAfericoes() {
            this.submitAfericao = []

            const data = {
                nr_placa: '',
                afericoes: this.submitAfericao
            }

            localStorage.afericao = JSON.stringify(data)

            this.$swal.fire({
                title: 'Sucesso!',
                text: this.$t('Leitura registrada com sucesso'),
                icon: 'success',
                timer: 1000
            })

            this.$bvModal.hide('modalMilimetragem')
        },

        resetarCampos() {
            this.inverterPneu = false
            // outros resets se quiser
        }
    },
    created() {
        this.adicionarClassePneu()
        this.disabledFinalizar = false

    }
}
</script>

<style src="./style.css" />
